import { render, staticRenderFns } from "./PeopleBackground.vue?vue&type=template&id=5715aef8&scoped=true&"
import script from "./PeopleBackground.vue?vue&type=script&lang=js&"
export * from "./PeopleBackground.vue?vue&type=script&lang=js&"
import style0 from "./PeopleBackground.vue?vue&type=style&index=0&id=5715aef8&scoped=true&lang=css&"
import style1 from "./PeopleBackground.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715aef8",
  null
  
)

export default component.exports